const initialState = {
	alert: null
}

const main = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'SHOW_ALERT':
			const { anchorOrigin, severity, message } = action.payload

			const alert = {
				anchorOrigin: anchorOrigin || { vertical: 'bottom', horizontal: 'left' },
				severity: severity || 'error',
				message
			}

			return { ...state, alert }
		case 'CLEAR_ALERT':
			return { ...state, alert: null }
		default:
			return state
	}
}

export default main
